import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { handleDeleteImmixAlert } from "./EditCameraUtils/handleDeleteImmixAlert";

export const DeleteImmixAlertDialog = ({
  deleteImmixAlertDialogOpen,
  setDeleteImmixAlertDialogOpen,
  setBackdropLoadingScreenOn,
  immixAlerts,
  setImmixAlerts,
  setActiveTab,
  setAddImmixAlertDialogOpen,
  setSendingImmixTest,
  setImmixTestSuccessDialogOpen,
  setImmixTestFailDialogOpen,
  sureviewAlerts,
  setAddSureviewAlertDialogOpen,
  cameraWebhookData,
  setAddStreamWebhookDialogOpen,
  setEditStreamWebhookDialogOpen,
  sentinelAlerts,
  setAddSentinelAlertDialogOpen,
  boldAlerts,
  setAddBoldAlertDialogOpen,
  patriotAlerts,
  setAddPatriotAlertDialogOpen,
  softguardAlerts,
  setAddSoftguardAlertDialogOpen,
  immixAlertsOnCamera,
  sureViewAlertsOnCamera,
  siteInfo,
  webhooksAlertsOnCamera,
  sentinelAlertsOnCamera,
  boldAlertsOnCamera,
  patriotAlertsOnCamera,
  softguardAlertsOnCamera,
  evalinkAlertsOnCamera,
  navigate,
}: {
  deleteImmixAlertDialogOpen: boolean;
  setDeleteImmixAlertDialogOpen: Dispatcher<boolean>;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  immixAlerts: any;
  setImmixAlerts: Dispatcher<any>;
  setActiveTab: Dispatcher<any>;
  setAddImmixAlertDialogOpen: Dispatcher<boolean>;
  setSendingImmixTest: Dispatcher<boolean>;
  setImmixTestSuccessDialogOpen: Dispatcher<boolean>;
  setImmixTestFailDialogOpen: Dispatcher<boolean>;
  sureviewAlerts: any;
  setAddSureviewAlertDialogOpen: any;
  cameraWebhookData: any;
  setAddStreamWebhookDialogOpen: any;
  setEditStreamWebhookDialogOpen: any;
  sentinelAlerts: any;
  setAddSentinelAlertDialogOpen: any;
  boldAlerts: any;
  setAddBoldAlertDialogOpen: any;
  patriotAlerts: any;
  setAddPatriotAlertDialogOpen: any;
  softguardAlerts: any;
  setAddSoftguardAlertDialogOpen: any;
  immixAlertsOnCamera: boolean;
  sureViewAlertsOnCamera: boolean;
  siteInfo: any;
  webhooksAlertsOnCamera: boolean;
  sentinelAlertsOnCamera: boolean;
  boldAlertsOnCamera: boolean;
  patriotAlertsOnCamera: boolean;
  softguardAlertsOnCamera: boolean;
  evalinkAlertsOnCamera: boolean;
  navigate: NavigateFunction;
}) => {
  const immixAlertId = localStorage.selectedImmixAlertId;

  return (
    <Dialog open={deleteImmixAlertDialogOpen}>
      <DialogTitle id="alert-dialog-title">
        {" Are you sure you want to delete this Alert?"}
      </DialogTitle>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setDeleteImmixAlertDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            setBackdropLoadingScreenOn(true);
            handleDeleteImmixAlert(
              immixAlertId,
              immixAlerts,
              setImmixAlerts,
              setActiveTab,
              setAddImmixAlertDialogOpen,
              setSendingImmixTest,
              setImmixTestSuccessDialogOpen,
              setImmixTestFailDialogOpen,
              setDeleteImmixAlertDialogOpen,
              setBackdropLoadingScreenOn,
              sureviewAlerts,
              setAddSureviewAlertDialogOpen,
              cameraWebhookData,
              setAddStreamWebhookDialogOpen,
              setEditStreamWebhookDialogOpen,
              sentinelAlerts,
              setAddSentinelAlertDialogOpen,
              boldAlerts,
              setAddBoldAlertDialogOpen,
              patriotAlerts,
              setAddPatriotAlertDialogOpen,
              softguardAlerts,
              setAddSoftguardAlertDialogOpen,
              immixAlertsOnCamera,
              sureViewAlertsOnCamera,
              siteInfo,
              webhooksAlertsOnCamera,
              sentinelAlertsOnCamera,
              boldAlertsOnCamera,
              patriotAlertsOnCamera,
              softguardAlertsOnCamera,
              evalinkAlertsOnCamera,
              navigate
            );
            setDeleteImmixAlertDialogOpen(false);
          }}
          text="Delete Alert"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
